var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 7.59549V12.008H9.81707V7.86455C9.81707 6.84213 9.44038 6.14258 8.52559 6.14258C7.82603 6.14258 7.39554 6.62688 7.2341 7.05737C7.18029 7.21881 7.12648 7.43406 7.12648 7.70311V12.008H4.54352C4.54352 12.008 4.59733 5.01253 4.54352 4.31298H7.12648V5.38921C7.44935 4.8511 8.09509 4.09773 9.44038 4.09773C11.1085 4.09773 12.4 5.22778 12.4 7.59549ZM1.85294 0.599976C0.991951 0.599976 0.400024 1.1919 0.400024 1.94527C0.400024 2.69863 0.93814 3.29056 1.79913 3.29056C2.71393 3.29056 3.25204 2.69863 3.25204 1.94527C3.30585 1.13809 2.76774 0.599976 1.85294 0.599976ZM0.561459 12.008H3.14442V4.31298H0.561459V12.008Z",
    fill: "var(--clr-primary)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f36fc676.svg";
export { ForwardRef as ReactComponent };